var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEcommerce = function SvgEcommerce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.602 4.776 1.544 15.926a2 2 0 0 0-.569 2.682l6.43 10.588a2 2 0 0 0 2.837.614l5.757-3.932 1.603-21.102Z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.215 5.4A2 2 0 0 1 33 6.988V30.5a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V6.988a2 2 0 0 1 .785-1.588l6.5-4.97a2 2 0 0 1 2.43 0l6.5 4.97ZM24.5 13a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z",
    clipRule: "evenodd"
  })));
};
export default SvgEcommerce;